export * from './avatar-tile-utils';

const wordsPool: string[] = [
  'sky',
  'star',
  'glow',
  'puff',
  'hue',
  'wink',
  'zap',
  'beam',
  'orb',
  'twirl',
  'blip',
  'pop',
  'mint',
  'gem',
  'zap',
  'lilac',
  'cloud',
  'wave',
  'pink',
  'loop',
  'hip',
  'hop',
  'jazz',
  'buzz',
  'fizz',
  'fun',
  'bun',
  'joy',
  'twink',
  'fizz',
  'flip',
  'daze',
  'whim',
  'mellow',
  'breeze',
  'charm',
  'frolic',
  'bloom',
  'twinkle',
  'glimmer',
  'swoop',
  'spritz',
  'whirl',
  'swirl',
  'whisp',
  'bop',
  'hush',
  'glee',
  'nod',
  'vibe',
  'giggle',
  'bliss',
  'chill',
  'flutter',
  'spark',
  'drift',
  'muse',
  'glint',
  'sway',
  'gleam',
  'glow',
  'drift',
  'whirl',
  'joy',
  'perk',
  'zing',
  'dash',
  'swish',
  'tingle',
  'quiver',
  'flick',
  'fizz',
  'hop',
  'skip',
  'flip',
  'flop',
  'twist',
  'doodle',
  'jolly',
  'breeze',
  'bubble',
  'chime',
  'clink',
  'dash',
  'dazzle',
  'dream',
  'glide',
  'hover',
  'laugh',
  'light',
  'peep',
  'puff',
  'sizzle',
  'smile',
  'sparkle',
  'trill',
  'twirl',
  'wave',
  'whisk',
];

/**
 * Returns a random word from the provided array of words.
 * @function getRandomWord
 * @param {string[]} words - The array of words to choose from.
 * @returns {string} A random word from the array.
 */
function getRandomWord(words: string[]): string {
  const randomIndex = Math.floor(Math.random() * words.length);
  return words[randomIndex] || '';
}

/**
 * Generates a random avatar name composed of words from the words pool.
 * The generated name will have a maximum length specified by the maxLength parameter.
 * @function generateAvatarName
 * @param {number} [maxLength=28] - The maximum length of the generated name.
 * @returns {string} The generated avatar name.
 */
export const generateAvatarName = (maxLength = 28): string => {
  let randomString = '';
  while (randomString.length < maxLength) {
    const word = getRandomWord(wordsPool);
    if (randomString.length + word.length + 1 <= maxLength) {
      if (randomString.length > 0) {
        randomString += '-';
      }
      randomString += word;
    } else {
      break;
    }
  }
  return randomString;
};
